<template>
  <v-list id="list" :two-line="twoLine">
    <header class="pa-4 list-header">
      {{ header }} <span v-if="showCounter">({{ counter }})</span>
    </header>
    <slot></slot>
  </v-list>
</template>

<script>
export default {
  name: 'EcsSideBarTileContent',

  props: {
    counter: {
      type: Number,
      default: 0
    },
    header: {
      type: String,
      default: ''
    },
    showCounter: {
      type: Boolean,
      default: false
    },
    twoLine: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
#list {
  width: 100%;
}
</style>
